import React from 'react';
import SelectBox from 'app/components/common/SelectBox/SelectBox';
import range from 'lodash/range';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

function YearMonthSelect({ year, month, minYearMonth = undefined, maxYearMonth = undefined, onChangeYearMonth }) {
	const ua = useSsrUserAgent();
	const selectSize = ua().isPc ? '40' : '50';
	const handleYear = (e) => {
		const newYear = Number(e.target.value);
		let newMonth = month;
		if (newYear === minYearMonth.year()) newMonth = Math.max(newMonth, minYearMonth.month() + 1);
		if (newYear === maxYearMonth.year()) newMonth = Math.min(newMonth, maxYearMonth.month() + 1);

		onChangeYearMonth([newYear, newMonth]);
	};

	const handleMonth = (e) => {
		onChangeYearMonth([year, Number(e.target.value)]);
	};

	return (
		<>
			<SelectBox
				name="selYear"
				id="selYear"
				value={year}
				data={range(minYearMonth.year(), maxYearMonth.year() + 1).map((i) => ({
					key: i,
					value: i,
					name: `${i}년`,
				}))}
				theme="uiselectbox_drop"
				onChange={handleYear}
				size={selectSize}
			/>
			<SelectBox
				name="selMonth"
				id="selMonth"
				value={month}
				data={range(
					year === minYearMonth.year() ? minYearMonth.month() + 1 : 1,
					year === maxYearMonth.year() ? maxYearMonth.month() + 2 : 13,
				).map((i) => ({
					key: i,
					value: i,
					name: `${i}월`,
				}))}
				theme="uiselectbox_drop"
				style={{ marginLeft: '10px' }}
				onChange={handleMonth}
				size={selectSize}
			/>
		</>
	);
}

export default YearMonthSelect;
